// String/Custom Attribute Filter Operators
export const STRING_OPERATORS = {
  CONTAINS_EXACTLY: 1,
  NOT_CONTAINS_EXACTLY: 2,
  IS_KNOWN: 3,
  IS_UNKNOWN: 4
}

// Number Filter Operators
export const NUMBER_OPERATORS = {
  IS_EQUAL_TO: 1,
  IS_NOT_EQUAL_TO: 2,
  IS_GREATER_THAN: 3,
  IS_GREATER_THAN_OR_EQUAL_TO: 4,
  IS_LESS_THAN: 5,
  IS_LESS_THAN_OR_EQUAL_TO: 6,
  IS_BETWEEN: 7,
  IS_KNOWN: 8,
  IS_UNKNOWN: 9
}

// Date Filter Operators
export const DATE_OPERATORS = {
  IS: 1,
  IS_EQUAL_TO: 2,
  IS_BEFORE: 3,
  IS_AFTER: 4,
  IS_BETWEEN: 5,
  IS_KNOWN: 6,
  IS_UNKNOWN: 7
}

// Operators that don't require values (IS_KNOWN/IS_UNKNOWN)
export const NO_VALUE_OPERATORS = [
  STRING_OPERATORS.IS_KNOWN,
  STRING_OPERATORS.IS_UNKNOWN,
  DATE_OPERATORS.IS_KNOWN,
  DATE_OPERATORS.IS_UNKNOWN,
  NUMBER_OPERATORS.IS_KNOWN,
  NUMBER_OPERATORS.IS_UNKNOWN
]

export const OPERATORS = {
  IS_ANY_OF: 1,
  IS_KNOWN: 2,
  IS_NONE_OF: 3,
  IS_UNKNOWN: 4
}
